export default __webpack_public_path__ + "388a25a1f35e26f2d8ac3ad4cff1137d.svg";